module.exports = __webpack_public_path__ + "files/b90a0ed4dee04a47595107626615b88b.png";